@if (showDropdown) {
    <form [formGroup]="facilityIdForm">
        <mat-form-field id="map-option-facility" class="w-100">
            <mat-label class="label-lg text-nowrap">{{ label }}</mat-label>
            <mat-select formControlName="paidToFacilityId">
                @for (facility of options; let index = $index; track facility) {
                    <mat-option [id]="'map-option-facility' + index" [value]="facility.paidToFacilityId">{{
                        facility.label
                    }}</mat-option>
                }
            </mat-select>
            <mat-error>
                <app-field-error
                    [field]="'paidToFacilityId'"
                    [messageList]="formFacilityIdErrors['paidToFacilityId']"
                ></app-field-error>
            </mat-error>
        </mat-form-field>
    </form>
}
